import { Button } from '@peacecover/component';
import { useTranslation } from 'react-i18next';
import { attachJosa } from '../../../utils/bettieUtils';
import type { components } from '../../../types/schema';

type CastRelationship = components['schemas']['ApiV1CastRelationship'];

const PreviewGeneratingPopup = ({
  onClose,
  castRelationship
}: {
  castRelationship: CastRelationship | null;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const { personA, personB } = castRelationship ?? {};

  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center">
      <div className="w-[311px] bg-backgroundElevated-dark rounded-[24px] px-[14px] pt-[32px] pb-[16px] flex flex-col items-center gap-[40px]">
        <div className="flex flex-col gap-[8px]">
          <p className="text-[17px] font-bold leading-[20px] text-main-dark-1 whitespace-pre-line text-center">
            {t('ScenePreviewDetail.generatingPopup.title', {
              personA: attachJosa(personA?.name ?? '', '과/와'),
              personB: personB?.name
            })}
          </p>
          <p className="text-[12px] leading-[15px] text-white whitespace-pre-line text-center">
            {t('ScenePreviewDetail.generatingPopup.description')}
          </p>
        </div>
        <Button size="large" className="w-full text-[17px] font-semibold" onClick={onClose}>
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
};

export default PreviewGeneratingPopup;
